import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/ReviewCards.css";

const MAX_STACKED_CARDS = 5;

const ReviewsSection = ({ reviews = [], currentReviewIndex = 0 }) => {
  const navigate = useNavigate();

  const handleFeedbackClick = () => {
    navigate("/website-feedback");
  };

  const handleSeeAllReviewsClick = () => {
    navigate("/reviews");
  };

  if (reviews.length === 0) {
    return null;
  }

  const visibleReviews = [];
  for (let i = 0; i < Math.min(MAX_STACKED_CARDS, reviews.length); i++) {
    visibleReviews.push(reviews[(currentReviewIndex + i) % reviews.length]);
  }

  return (
    <div className="section home-reviews">
      <h2 className="section-title">What Our Users Say</h2>
      <div className="home-reviews-container">
        <div className="card-stack">
          <ul className="card-list">
            {visibleReviews.map((review) => (
              <li key={review.id} className="review-card-item">
                <div className="review-card">
                  <div className="review-header">
                    <div className="review-stars">
                      {[...Array(review.stars)].map((_, starIdx) => (
                        <i key={starIdx} className="fas fa-star star-icon"></i>
                      ))}
                    </div>
                    <p className="review-meta">
                      {review.name} | {review.date}
                    </p>
                  </div>
                  {review.content && (
                    <div className="review-content-wrapper">
                      <p className="review-content">"{review.content}"</p>
                    </div>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="reviews-footer">
        <button
          className="feedback-button"
          onClick={handleFeedbackClick}
        >
          Let Us Know What You Think
        </button>
        <button
          className="see-all-button"
          onClick={handleSeeAllReviewsClick}
        >
          See All Reviews
        </button>
      </div>
    </div>
  );
};

export default ReviewsSection;
